<template>
  <div>
    <div>{{ additiveFeesText || '-' }}</div>
    <div>{{ column.recruiterOwnershipDays }} {{ $t('days') }}</div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { FeeApplication } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const RecruiterPlacementTermsColumn = graphql(`
  fragment RecruiterPlacementTermsColumn on Hire {
    fees {
      id
      application
      formattedRate
    }
    recruiterOwnershipDays
  }
`)

const props = defineProps<{ row: FragmentType<typeof RecruiterPlacementTermsColumn> }>()
const column = computed(() => useFragment(RecruiterPlacementTermsColumn, props.row))
const additiveFeesText = computed(() =>
  column.value.fees
    .filter((fee) => fee.application === FeeApplication.Additive)
    .map((fee) => fee.formattedRate)
    .join(' + '),
)
</script>
